import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core";
import {NavigationEnd, Router} from "@angular/router";
import {descryptValue, encryptStorage} from "src/app/auth/utils/storage";
import {CognitoService} from "src/app/shared/services/cognito.service";

@Component({
  selector: "app-sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
})
export class SidenavComponent implements OnInit {
  @ViewChild("sidebar", {static: false}) sidebar: ElementRef;
  @ViewChild("toggle", {static: false}) toggle: ElementRef;
  @ViewChild("search", {static: false}) search: ElementRef;
  @ViewChild("body", {static: false}) body: ElementRef;

  usuario: string = "";
  tipoPessoa: string = "";
  menuItems: any[] = [];
  mensagem: string = "Seja bem-vindo ao Portal Investidor!";
  rotaAtual: string = "";

  constructor(
    private cognitoService: CognitoService,
    private renderer: Renderer2,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.usuario = encryptStorage.getItem("@user", false);
    this.tipoPessoa = encryptStorage.getItem("@tipoPessoa", false);
    this.rotaAtual = this.router.url;
    this.menuItems = this.createMenuItems(
      "ENTIDADE",
      encryptStorage.getItem("@documentoIdentificador")
    );

    this.setMensagem();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.rotaAtual = event.urlAfterRedirects;
        this.setMensagem();
      }
    });
  }

  setMensagem() {
    const path = this.router.url;

    if (path.includes("/spg/solicita-garantia/")) {
      this.mensagem =
        "Selecione a conta bancária que deseja receber sua garantia";
      return;
    }

    if (path.includes("/perfil-investidor")) {
      this.mensagem = "Consulte ou edite seus dados de perfil";
      return;
    }

    const item = this.menuItems.find((i) => i.urlPath === path);
    this.mensagem = item?.message || "Seja bem-vindo ao Portal Investidor!";
  }

  resetStorage() {
    this.cognitoService.logout();
  }

  goToDetail(item) {
    this.rotaAtual = item;
    this.router.navigateByUrl(item);
  }

  private createMenuItems(
    perfilUsuario: string,
    documentoIdentificador: string
  ) {
    let userActions: any[] = [];

    switch (perfilUsuario) {
      case "ENTIDADE": {
        userActions = [
          {
            urlPath: "/spg/home-ordinaria",
            nameItem: "Garantia Ordinária",
            icon: "fas fas fa-university icon",
            message: "Gerencie seus pedidos de garantia ordinária"
          },
          {
            urlPath: "/spg/home-dpge",
            nameItem: "Garantia DPGE (Especial)",
            icon: "fas fa-file-alt icon",
            message: "Gerencie seus pedidos de garantia DPGE (Especial)"
          },
          {
            urlPath: "/spg/perfil-investidor",
            nameItem: "Meu Perfil",
            icon: "fas fa-user icon",
            message: "Consulte ou edite seus dados de perfil"
          },
        ];
        break;
      }
      case "InvestidorFI".toUpperCase(): {
        userActions = [
          {
            urlPath: "/spg/home-ordinaria",
            nameItem: "Garantia Ordinária",
            icon: "fas fas fa-university icon",
            message: "Gerencie seus pedidos de garantia ordinária"
          },
          {
            urlPath: "/spg/home-dpge",
            nameItem: "Garantia DPGE (Especial)",
            icon: "fas fa-file-alt icon",
            message: "Gerencie seus pedidos de garantia DPGE (Especial)"
          },
          {
            urlPath: "/spg/perfil-investidor",
            nameItem: "Meu Perfil",
            icon: "fas fa-user icon",
            message: "Consulte ou edite seus dados de perfil"
          },
        ];
        break;
      }
      case "INVESTIDOR": {
        if (documentoIdentificador.length > 13) {
          userActions = [
            {
              urlPath: "/spg/home-ordinaria",
              nameItem: "Garantia Ordinária",
              icon: "fas fas fa-university icon",
              message: "Gerencie seus pedidos de garantia ordinária"
            },
            {
              urlPath: "/spg/home-dpge",
              nameItem: "Garantia DPGE (Especial)",
              icon: "fas fa-file-alt icon",
              message: "Gerencie seus pedidos de garantia DPGE (Especial)"
            },
            {
              urlPath: "/spg/perfil-investidor",
              nameItem: "Meu Perfil",
              icon: "fas fa-user icon",
              message: "Consulte ou edite seus dados de perfil"
            },
          ];
        } else {
          userActions = [
            {
              urlPath: "/spg/home-dpge",
              nameItem: "Garantia DPGE (Especial)",
              icon: "fas fa-file-alt icon",
              message: "Gerencie seus pedidos de garantia DPGE (Especial)"
            },
            {
              urlPath: "/spg/perfil-investidor",
              nameItem: "Meu Perfil",
              icon: "fas fa-user icon",
              message: "Consulte ou edite seus dados de perfil"
            },
          ];
        }
        break;
      }

      default: {
        userActions = ["NO_ACCESS"];
        break;
      }
    }

    return userActions;
  }
}
